import packageJson from '../../package.json';

export const environment = {
  production: false,
  version: packageJson.version,
  pageSize: 50,
  email: 'arantxa.salgado@daimlertruck.com',
  TOKEN: 'jwt',
  REFRESH_TOKEN: 'refreshToken',
  DEALERS_SITE:
    'https://qa-dealers.daimlertruck-financialservices.mx/SitioDistribuidoresB/app/home/home.zul?',
  API_AUTH_SERVICE: 'https://dealers-back-qa.bshouse.io/auth-service/api/v1',
  API_DEALEARS_SERVICE:
    'https://dealers-back-qa.bshouse.io/dealer-service/api/v1',
  API_NOTIFICATION_SERVICE:
    'https://dealers-back-qa.bshouse.io/notification-service/api/v1',
  API_USER_SERVICE: 'https://dealers-back-qa.bshouse.io/user-service/api/v1',
  API_WHOLESALE_SERVICE:
    'https://dealers-back-qa.bshouse.io/wholesale-service/api/v1',
  API_PROCOTIZA:
    'https://qa-ms.daimlertruck-financialservices.mx/middleware/telepro/v1/refresh-token',
  API_MAILSHOT_SERVICE:
    'https://dealers-back-qa.bshouse.io/mailshot-service/api/v1',
  API_FILE_SERVICE: 'https://dealers-back-qa.bshouse.io/file-service/api/v1',
  API_QUOTE_SERVICE: 'https://dealers-back-qa.bshouse.io/quote-service/api/v1',
  API_CLIENTS_SERVICE: 'https://dealers-back-qa.bshouse.io/customer-service/api/v1',
  API_MARKETING_SERVICE: 'https://dealers-back-qa.bshouse.io/marketing-service/api/v1',
  API_CREDIT_REQUEST_SERVICE: "https://dealers-back-qa.bshouse.io/credit-request-service/api/v1",
  activarDiro:true,
  testDiro:false,
  API_DIRO_SERVICE: 'https://dealers-back-dev.bshouse.io/diro-service/api/v1',
  tracking_id: '489bcc53991682fd0179b6f2c862d6b6',
  downloadJson: true,
  active_client_catalog: true,
  is_active_mixpanel: false,
  useAccountStatesComponent: true,
  ONBOARDING_ACTIVE: true,
  QA_HIDE_ONBOARDING: false,
  HIDE_DRM_REGION: true,
  METAMAP_ACTIVE: true,
  usePlanPisoFilter: true,
  activeQuoteListValidStatusFilter: true,
  showQuoteValidityListFilter: true,
  quoteListValidStatusDefault: null as boolean | null,
  showFinancialSetupQuoteValidityDays: true,
  featureLoyaltyFeriaQuotation: true,
  onboardingExtendValidityAllowRepeat: true,
  QUALITY_KPI_SHEETS_ACTIVE: true,
  mailshotRecipientsImprovements: true,
};
